import React, { useEffect } from "react";
import Header from "../Templete/Header";
import Footer from "../Templete/Footer";

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Privacy Policy | FORMAX PAY";
  }, []);

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>
            Your privacy matters. Learn how we protect and manage your data in
            compliance with Indian laws.
          </p>
        </div>
      </section>

      <div className="container">
        <div className="privacy-content">
          <div className="privacy-card">
            <h2>1. Introduction & Consent</h2>
            <p>
              FORMAX PAY (operated by{" "}
              <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>) respects
              your privacy. This Privacy Policy explains how we collect, use,
              disclose, and safeguard your information when you use our website,
              mobile application, or services (collectively, the "Services").
            </p>
            <p>
              By accessing or using our Services, you consent to the practices
              described in this policy. If you do not agree, please do not use
              our Services.
            </p>
          </div>

          <div className="privacy-card">
            <h2>2. Information We Collect</h2>
            <p>
              To provide you with seamless recharge and bill payment services,
              we may collect the following categories of personal information:
            </p>
            <ul>
              <li>
                <strong>Identity & Contact Data:</strong> Name, email address,
                mobile number, date of birth (if required for verification), and
                correspondence address.
              </li>
              <li>
                <strong>Transaction Data:</strong> Details of recharges, bill
                payments, voucher purchases, amounts, timestamps,
                operator/consumer IDs, and transaction status.
              </li>
              <li>
                <strong>Technical & Usage Data:</strong> IP address, browser
                type, device identifiers, operating system, referral URLs, and
                browsing actions on our platform.
              </li>
              <li>
                <strong>Communication Data:</strong> Records of your
                interactions with our customer support team (calls, emails,
                chats).
              </li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>3. Legal Basis for Processing (Indian Compliance)</h2>
            <p>
              Under Indian law, we process your personal information based on:
            </p>
            <ul>
              <li>
                <strong>Consent:</strong> You have provided explicit consent for
                specific purposes.
              </li>
              <li>
                <strong>Contractual Necessity:</strong> To perform the services
                you request (recharges, bill payments).
              </li>
              <li>
                <strong>Legal Obligation:</strong> To comply with applicable
                laws (e.g., KYC, tax reporting).
              </li>
              <li>
                <strong>Legitimate Interests:</strong> To prevent fraud, improve
                security, and enhance user experience.
              </li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>4. How We Use Your Information</h2>
            <p>
              We use your personal information only for legitimate business
              purposes:
            </p>
            <ul>
              <li>
                Process and confirm your recharges, bill payments, and voucher
                orders.
              </li>
              <li>
                Send transaction confirmations, receipts, and service updates
                via SMS/email.
              </li>
              <li>
                Respond to your queries, complaints, and support requests.
              </li>
              <li>
                Detect and prevent fraudulent, unauthorised, or illegal
                activities.
              </li>
              <li>
                Comply with legal, regulatory, and law enforcement requests.
              </li>
              <li>
                Improve our platform, analyse usage trends, and personalise your
                experience.
              </li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>5. Data Sharing & Disclosure</h2>
            <p>
              We do not sell, rent, or trade your personal information. However,
              we may share your data with:
            </p>
            <ul>
              <li>
                <strong>Service Providers & Partners:</strong> Telecom
                operators, utility companies, payment gateways, and voucher
                suppliers – only to fulfil your transactions.
              </li>
              <li>
                <strong>Government & Law Enforcement:</strong> When required by
                law, court order, or governmental authority (e.g., under the IT
                Act, 2000).
              </li>
              <li>
                <strong>Business Transfers:</strong> In case of merger,
                acquisition, or asset sale, your information may be transferred
                with prior notice.
              </li>
            </ul>
            <p>
              All third parties are contractually bound to protect your data and
              use it only for the specified purposes.
            </p>
          </div>

          <div className="privacy-card">
            <h2>6. Data Security & Retention</h2>
            <p>
              We implement industry-standard security measures, including SSL
              encryption, firewalls, role-based access controls, and regular
              security audits to protect your personal information from
              unauthorised access, alteration, or destruction.
            </p>
            <p>
              We retain your personal information only as long as necessary to
              fulfil the purposes outlined in this policy, comply with legal
              obligations, resolve disputes, and enforce our agreements.
              Typically, transaction data is retained for{" "}
              <strong>7 years</strong> as required by Indian tax laws.
            </p>
          </div>

          <div className="privacy-card">
            <h2>7. Cookies & Tracking Technologies</h2>
            <p>
              We use cookies, web beacons, and similar technologies to enhance
              your browsing experience, analyse traffic, and remember
              preferences. You can control cookies through your browser
              settings. Disabling cookies may affect certain features of our
              website.
            </p>
            <p>
              <strong>Types of cookies we use:</strong> Essential (for website
              functionality), Performance (analytics), Functional (preferences),
              and Targeting (advertising – only with your consent).
            </p>
          </div>

          <div className="privacy-card">
            <h2>8. Your Rights (Under Indian Law)</h2>
            <p>As a user in India, you have the following rights:</p>
            <ul>
              <li>
                <strong>Right to Access:</strong> Request a copy of your
                personal information we hold.
              </li>
              <li>
                <strong>Right to Correction:</strong> Update or correct
                inaccurate data.
              </li>
              <li>
                <strong>Right to Withdraw Consent:</strong> Withdraw consent for
                processing (where consent is the basis).
              </li>
              <li>
                <strong>Right to Grievance Redressal:</strong> Lodge a complaint
                with our Grievance Officer (see Section 12).
              </li>
            </ul>
            <p>
              To exercise these rights, contact us at{" "}
              <strong>support@formaxpay.in</strong>. We will respond within 30
              days as mandated by law.
            </p>
          </div>

          <div className="privacy-card">
            <h2>9. Cross-Border Data Transfer</h2>
            <p>
              Your personal information is primarily stored on servers located
              in India. If we engage service providers outside India (e.g.,
              cloud infrastructure), we ensure adequate safeguards and
              compliance with the SPDI Rules and DPDP Act provisions.
            </p>
          </div>

          <div className="privacy-card">
            <h2>10. Children's Privacy</h2>
            <p>
              Our Services are not intended for individuals under the age of 18.
              We do not knowingly collect personal information from minors. If
              we become aware that a minor has provided us with personal data,
              we will delete it immediately. Parents or guardians may contact us
              to report such instances.
            </p>
          </div>

          <div className="privacy-card">
            <h2>11. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time to reflect
              changes in our practices, technology, or legal requirements.
              Significant changes will be notified via email or a prominent
              notice on our website.
            </p>
          </div>

          <div className="privacy-card">
            <h2>12. Grievance Officer (Nodal Contact Person)</h2>
            <p>
              In compliance with Rule 5(9) of the Information Technology
              (Reasonable Security Practices and Procedures and Sensitive
              Personal Data or Information) Rules, 2011, the Grievance Officer
              for data protection matters is:
            </p>
            <p>
              <strong>Name:</strong> Mr. Ezazul Haque (Compliance Officer)
              <br />
              <strong>Email:</strong> support@formaxpay.in
              <br />
              <strong>Phone:</strong> +91 7890090500
              <br />
              <strong>Address:</strong> N0060, Mochpole, Near Junior School,
              Nabapally, Barasat, Kolkata - 700126, West Bengal, India
            </p>
            <p>
              Any complaints or concerns regarding data handling should be sent
              to the Grievance Officer. We will acknowledge your complaint
              within 24 hours and endeavour to resolve it within one month.
            </p>
          </div>

          <div className="privacy-card">
            <h2>13. Contact Us</h2>
            <p>
              For any questions about this Privacy Policy or your data, please
              contact:
            </p>
            <p>
              <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>
              <br />
              N0060, Mochpole, Near Junior School, Nabapally, Barasat,
              <br />
              Kolkata - 700126, West Bengal, India
              <br />
              Email: support@formaxpay.in
              <br />
              Phone: +91 7890090500
            </p>
          </div>
        </div>
      </div>

      <Footer />

      {/* Additional CSS for privacy page */}
      <style>{`
        .page-hero {
          background: linear-gradient(120deg, #eef2ff 0%, #f0f9ff 100%);
          padding: 50px 0 60px;
          text-align: center;
        }
        .page-hero h1 {
          font-size: 2.8rem;
          margin-bottom: 12px;
        }
        .page-hero p {
          color: #334155;
          max-width: 600px;
          margin: 0 auto;
        }
        .privacy-content {
          margin: 60px 0;
        }
        .privacy-card {
          background: white;
          border-radius: 28px;
          padding: 32px;
          margin-bottom: 30px;
          box-shadow: var(--shadow-sm, 0 10px 25px -5px rgba(0,0,0,0.05));
          border: 1px solid #eef2ff;
        }
        .privacy-card h2 {
          font-size: 1.6rem;
          margin-bottom: 16px;
          color: #0f172a;
        }
        .privacy-card p {
          margin-bottom: 16px;
          line-height: 1.6;
          color: #334155;
        }
        .privacy-card ul {
          margin-left: 24px;
          margin-bottom: 8px;
        }
        .privacy-card li {
          margin-bottom: 10px;
          line-height: 1.5;
          color: #334155;
        }
        .privacy-footer-note {
          text-align: center;
          margin-top: 30px;
          font-size: 0.9rem;
          color: #64748b;
        }
        @media (max-width: 720px) {
          .page-hero h1 { font-size: 2rem; }
          .privacy-card h2 { font-size: 1.3rem; }
          .privacy-card { padding: 24px; }
        }
      `}</style>
    </>
  );
};

export default PrivacyPolicy;
